// extracted by mini-css-extract-plugin
export default {"footer":"footView_footer__PbYaW"};